import { useEffect } from 'react';
import { usePreferencesStore, Theme } from '../state/preferencesStore';

// Theme state lives in the shared preferences store (ywt-preferences); this
// component only applies the chosen theme to <html> after hydration. The
// inline script in app/root.tsx applies it before first paint — keep the two
// in sync when changing how the theme class is resolved.
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = usePreferencesStore((s) => s.theme);

  useEffect(() => {
    const root = window.document.documentElement;

    root.classList.remove('light', 'dark');

    if (theme === 'system') {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

      root.classList.add(systemTheme);
      return;
    }

    root.classList.add(theme);
  }, [theme]);

  return <>{children}</>;
}

export const useTheme = (): { theme: Theme; setTheme: (theme: Theme) => void } => {
  const theme = usePreferencesStore((s) => s.theme);
  const setTheme = usePreferencesStore((s) => s.setTheme);

  return { theme, setTheme };
};
